import { Box, styled } from '@mui/material';

export const StyledLabel = styled(Box)(() => ({
  fontSize: '14px',
  fontWeight: 500,
  padding: '4px 12px',
  borderRadius: '16px',
  width: 'fit-content',
}));

export const StyledFreeTierLabel = styled(StyledLabel)(() => ({
  backgroundColor: '#DEF7EC',
  color: '#166534',
}));

export const SubscribedLabel = styled(StyledLabel)(() => ({
  backgroundColor: ' #E0E4FF',
  color: '#2C3050',
}));

export const StyledPaygLabel = styled(StyledLabel)(() => ({
  backgroundColor: '#DBEAFE',
  color: '#1E40AF',
}));
